var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_514_2746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7363 26.5002V19.6157H26.6756H33.6148V26.5002V33.3846H26.6756H19.7363V26.5002Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7363 11.2691V4.38461H26.6756H33.6148V11.2691V18.1535H26.6756H19.7363V11.2691Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38477 26.5002V19.6157H11.324H18.2632V26.5002V33.3846H11.324H4.38477V26.5002Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38477 11.2691V4.38461H11.324H18.2632V11.2691V18.1535H11.324H4.38477V11.2691Z",
    fill: "#434343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_514_2746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.2308,
    height: 29,
    fill: "white",
    transform: "translate(4.38477 4.38461)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinIcon);
export default __webpack_public_path__ + "static/media/win-icon.a6250ded0c26915ce627c2335e2b254f.svg";
export { ForwardRef as ReactComponent };